import { Button, Flex, Form, Select } from "antd";
import { FC } from "react";
import { useIntl } from "react-intl";
import SalonSVG from "../../../assets/teamMember/SalonSVG";
import { DownOutlined, PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { localizedTeamMemberPermission } from "../../../enum/teamMemberPermission";
import { useSelector } from "react-redux";
import { location } from "../../../types/calendar";

interface LocationPermissionsProps {
  listLocations: location[];
  showMinForm: boolean | undefined;
  selectedLocations: {
    id: number;
    key: number;
  }[];
  setSelectedLocations: React.Dispatch<
    React.SetStateAction<
      {
        id: number;
        key: number;
      }[]
    >
  >;

  config: {
    isAdmin?: boolean;
    teamMemberId?: number;
    locationId: number;
    locationName?: string;
    isEdit?: boolean;
    salonName?: string;
  };
}

const LocationPermissions: FC<LocationPermissionsProps> = ({
  listLocations,
  config,
  showMinForm,
  selectedLocations,
  setSelectedLocations,
}) => {
  const intl = useIntl();
  const { currentLang } = useSelector(
    (state: { user: { currentLang: "en" | "ar" } }) => {
      return {
        currentLang: state.user.currentLang,
      };
    }
  );

  return (
    <div style={{ display: showMinForm ? "none" : "block" }}>
      <Form.List name="location_permissions">
        {(fields, { add, remove }) => (
          <>
            <Form.Item className="p-5 rounded bg-color-light-gr w-full text-color-primary">
              {fields.map(({ key, name, ...restField }, index) => (
                <div className="flex flex-col md:flex-row justify-center md:justify-between">
                  <Flex wrap="wrap">
                    <Form.Item className="min-w-[130px]">
                      {index === 0
                        ? intl.formatMessage({
                            id: "basicBranchForMember",
                            defaultMessage: "الفرع الاساسي للعضو",
                          })
                        : intl.formatMessage({
                            id: "additionalBranchForMember",
                            defaultMessage: "فرع اضافي للعضو ",
                          })}
                    </Form.Item>
                    <div>
                      <Form.Item
                        {...restField}
                        required={false}
                        className="px-3"
                        name={[name, "location_id"]}
                        // initialValue={
                        //   key === 0 && listLocations?.data?.[0]?.id
                        // }
                      >
                        <Select
                          placeholder={intl.formatMessage({
                            id: "selectBranch",
                            defaultMessage: "اختر الفرع",
                          })}
                          className="bg-color-light rounded-md p-2  min-w-[160px]"
                          bordered={false}
                          // defaultActiveFirstOption={key === 0}
                          onChange={(val) => {
                            const newLocationWithKey = {
                              key: key,
                              id: +val,
                            };
                            const existedIndex = selectedLocations.findIndex(
                              (loc, i) => loc.key === key
                            );
                            if (existedIndex === -1) {
                              setSelectedLocations([
                                ...selectedLocations,
                                newLocationWithKey,
                              ]);
                            } else {
                              setSelectedLocations(
                                selectedLocations.map((loc, i) => {
                                  if (loc.key === key) {
                                    return newLocationWithKey;
                                  } else {
                                    return loc;
                                  }
                                })
                              );
                            }
                          }}
                          options={
                            listLocations?.map((item: location) => {
                              const selectedBefore = selectedLocations.find(
                                (selectedLocation, i) => {
                                  return selectedLocation.id === item.id;
                                }
                              );

                              return {
                                value: item.id,
                                label: item.name,
                                disabled: !!selectedBefore,
                              };
                            }) || [
                              {
                                value: config?.locationId
                                  ? config?.locationId
                                  : 0,
                                label: config?.locationName
                                  ? config?.locationName
                                  : "",
                                disabled: true,
                              },
                            ]
                          }
                          style={{
                            position: "relative",
                            paddingRight: "10px",
                          }}
                          suffixIcon={
                            <div className="ms-4">
                              <SalonSVG />
                              <DownOutlined />
                            </div>
                          }
                        />
                      </Form.Item>
                    </div>
                  </Flex>
                  <Flex wrap="wrap">
                    <Form.Item>
                      {intl.formatMessage({
                        id: "memberPermissionsonBranch",
                        defaultMessage: "صلاحيات العضو في الفرع",
                      })}
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      className="px-3"
                      required={false}
                      name={[name, "permission"]}
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "memberPermissionsonBranch",
                            defaultMessage: "صلاحيات العضو في الفرع",
                          }),
                        },
                      ]}
                    >
                      <Select
                        placeholder={intl.formatMessage({
                          id: "selectPermission",
                          defaultMessage: "اختر الصلاحيات",
                        })}
                        className="w-full my-input min-w-[150px]"
                        options={localizedTeamMemberPermission.map((item) => ({
                          value: item.value,
                          label: item?.label[currentLang],
                        }))}
                        defaultActiveFirstOption
                        popupMatchSelectWidth={false}
                      />
                    </Form.Item>
                    <div>
                      {index === 0 ? (
                        <Button
                          className="border-none  shadow-none outline-none"
                          onClick={() => {
                            add();
                          }}
                          disabled={
                            fields.length >= listLocations?.length ||
                            !listLocations
                          }
                          block
                          icon={
                            <PlusOutlined className="bg-[#00086D] text-white p-1 rounded-md" />
                          }
                        />
                      ) : (
                        <>
                          <Button
                            className="border-none  shadow-none outline-none invisiblee "
                            onClick={() => {
                              remove(index);
                              setSelectedLocations(
                                selectedLocations.filter(
                                  (loc, i) => loc.key !== key
                                )
                              );
                            }}
                            block
                            icon={
                              <MinusOutlined className="bg-[red] text-white p-1 rounded-md" />
                            }
                          />
                        </>
                      )}
                    </div>
                  </Flex>
                </div>
              ))}
            </Form.Item>
          </>
        )}
      </Form.List>
    </div>
  );
};

export default LocationPermissions;
